export type PendingTab = {
	/** Points the tab at `url`, or this tab when the popup was blocked. */
	navigate: (url: string) => void;
	cancel: () => void;
};

/**
 * Opens a blank tab straight away, while the click's user activation still
 * holds, so it can be pointed at a URL that is only known after an await.
 */
export const openPendingTab = (): PendingTab => {
	// No "noopener" here — that makes window.open return null; null opener does the same isolation.
	const opened = window.open("about:blank", "_blank");
	if (opened) {
		opened.opener = null;
	}

	return {
		navigate: (url) => {
			if (opened) {
				opened.location.href = url;
			} else {
				window.location.href = url;
			}
		},
		cancel: () => opened?.close(),
	};
};
